module.exports = __webpack_public_path__ + "img/twitter.0fe50265.svg";